import React, { createContext, useState, useEffect, useContext } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { v4 as uuidv4 } from 'uuid';

const RequestContext = createContext(null);

export const RequestProvider = ({ children }) => {
  const [requestId, setRequestId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { user } = useAuth0();

  const createRequest = async () => {
    if (!user) return;

    try {
      setLoading(true);

      const requestId = uuidv4();
      console.log('New request created with ID:', requestId);

      setRequestId(requestId);
    } catch (err) {
      console.error('Error creating request:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // Function to create a new request (for reset scenarios)
  const createNewRequest = async () => {
    console.log('Creating new request...');
    setRequestId(null); // Reset current request ID
    await createRequest();
  };

  useEffect(() => {
    if (user && !requestId) {
      createRequest();
    }
  }, [user, requestId]);

  const value = {
    requestId,
    requestLoading: loading,
    requestError: error,
    createNewRequest,
  };

  return (
    <RequestContext.Provider value={value}>{children}</RequestContext.Provider>
  );
};

export const useRequest = () => {
  return useContext(RequestContext);
};
